export default __webpack_public_path__ + "static/media/wrong-answer.156df797.mp3";